import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchAddressRecords, fetchRecords } from './member.action';

@Injectable({ providedIn: 'root' })
export class MemberAddressTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                id: '',
                created_at: '',
                member_number: '',
                member_name: '',
                club_name: null,
                dossier_outstanding_amount: '',
                amount_of_dossiers: '',
                member_status: null
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    memberId = 0;
    statuses = [
        {"id": "1", "name": "COMMON.enable"},
        {"id": "2", "name": "COMMON.disable"}
    ];
    clubs = [];
    columns = [
                { prop: 'id', name: 'MEMBER.member-id', sortable: true, hasFilter: true, filter: "input", widthSet: 100},
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 155},
                { prop: 'member_number', name: 'MEMBER.member-number', sortable: true, hasFilter: true, filter: "input", widthSet: 155},
                { prop: 'member_name', name: 'MEMBER.member-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'club_name', name: 'MEMBER.club', sortable: true, hasFilter: true, filter: "select", options: 'clubs', options_id: "id", options_label: "club_name"},
                { prop: 'amount_of_dossiers', name: 'MEMBER.amount-of-dossiers', sortable: true, hasFilter: false, filter: "select", options: 'clubs', options_id: "id", options_label: "club_name"},
                { prop: 'dossier_outstanding_amount', name: 'MEMBER.outstanding', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'member_status', name: 'COMMON.status', sortable: true, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "name"},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchAddressRecords({memberId: this.memberId}));
    }

    hasActiveFilters(){
        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetState(){
        this.filters = {
            id: '',
            created_at: '',
            member_number: '',
            member_name: '',
            club_name: null,
            dossier_outstanding_amount: '',
            amount_of_dossiers: '',
            member_status: null
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

}